// src/components/MailchimpFormEmbed.jsx
import React, { useEffect, useRef } from 'react';

const mailchimpFormOnlyHtml = `
  <div id="mc_embed_signup">
    <form action="https://iedp.us8.list-manage.com/subscribe/post?u=c7ff33fac7c93057c81041268&amp;id=dcab9578af&amp;v_id=2768&amp;f_id=00197be1f0" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" class="validate" target="_blank">
      <div id="mc_embed_signup_scroll">
        <div class="mailchimp-input-grid">
            <div class="mc-field-group">
              <label for="mce-FNAME">First Name <span class="asterisk">*</span></label>
              <input type="text" name="FNAME" class="required text" id="mce-FNAME" value="" required="">
            </div>
            <div class="mc-field-group">
              <label for="mce-LNAME">Last Name <span class="asterisk">*</span></label>
              <input type="text" name="LNAME" class="required text" id="mce-LNAME" value="" required="">
            </div>
            <div class="mc-field-group">
              <label for="mce-ORG">Organization <span class="asterisk">*</span></label>
              <input type="text" name="ORG" class="required text" id="mce-ORG" value="" required="">
            </div>
            <div class="mc-field-group">
              <label for="mce-EMAIL">Email Address <span class="asterisk">*</span></label>
              <input type="email" name="EMAIL" class="required email" id="mce-EMAIL" required="" value="">
            </div>
        </div>

        <div id="mergeRow-gdpr" class="mergeRow gdpr-mergeRow content__gdprBlock mc-field-group">
          <div class="content__gdpr">
            <label>Consent for Communications</label>
            <p>Please let us know which types of communications you’d like to receive from Nexed Insight. You can change your preferences at any time.</p>
            <fieldset class="mc_fieldset gdprRequired mc-field-group" name="interestgroup_field">
             <label class="checkbox subfield gdpr-newsletter-label" for="gdpr_36661"> <input type="checkbox" id="gdpr_36661" name="gdpr[36661]" class="gdpr" value="Y">
  <span>Nexed Intelligence Network</span>
</label>
            </fieldset>
          </div>
          <div class="content__gdprLegal">
            <p>We use Mailchimp as our marketing platform. By clicking below to subscribe, you acknowledge that your information will be transferred to Mailchimp for processing. <a href="https://mailchimp.com/legal/terms" target="_blank" rel="noopener noreferrer">Learn more</a> about Mailchimp's privacy practices.</p>
          </div>
        </div>
        <div id="mce-responses" class="clear">
          <div class="response" id="mce-error-response" style="display: none;"></div>
          <div class="response" id="mce-success-response" style="display: none;"></div>
        </div>
        <div aria-hidden="true" style="position: absolute; left: -5000px;">
          <input type="text" name="b_c7ff33fac7c93057c81041268_dcab9578af" tabindex="-1" value="">
        </div>
        <div class="clear">
          <input type="submit" name="subscribe" id="mc-embedded-subscribe" class="button" value="Subscribe">
        </div>
        <p class="small-unsubscribe-text">You can unsubscribe at any time by clicking the link in the footer of our emails. For more on how we handle your data, visit our Privacy Policy.</p>
      </div>
    </form>
  </div>
`;

const mailchimpScriptContent = `
  (function($) {
    window.fnames = new Array();
    window.ftypes = new Array();
    fnames[1] = 'FNAME'; ftypes[1] = 'text';
    fnames[2] = 'LNAME'; ftypes[2] = 'text';
    fnames[5] = 'ORG'; ftypes[5] = 'text';
    fnames[0] = 'EMAIL'; ftypes[0] = 'email';
    fnames[3] = 'ADDRESS'; ftypes[3] = 'address';
    fnames[4] = 'PHONE'; ftypes[4] = 'phone';
  }(jQuery));
  var $mcj = jQuery.noConflict(true);
`;

const MailchimpFormEmbed = () => {
  const containerRef = useRef(null);

  useEffect(() => {
    const currentContainer = containerRef.current;
    if (currentContainer) {
      currentContainer.innerHTML = mailchimpFormOnlyHtml;

      const head = document.head;
      const body = document.body;

      // Clean up previous Mailchimp scripts/styles if they exist
      const cleanupOldMailchimpElements = () => {
        document.querySelectorAll('link[href*="mailchimp.com"], style[data-mailchimp-style], script[src*="mc-validate.js"], script[data-mailchimp-inline]').forEach(el => el.remove());
      };
      cleanupOldMailchimpElements();


      // Load Mailchimp's external CSS link
      const link = document.createElement('link');
      link.href = "//cdn-images.mailchimp.com/embedcode/classic-061523.css";
      link.rel = "stylesheet";
      link.type = "text/css";
      link.setAttribute('data-mailchimp-style', 'true'); // Add custom attribute for easier cleanup
      head.appendChild(link);

      // Load Mailchimp's validation script
      const scriptExternal = document.createElement('script');
      scriptExternal.type = 'text/javascript';
      scriptExternal.src = "//s3.amazonaws.com/downloads.mailchimp.com/js/mc-validate.js";
      scriptExternal.setAttribute('data-mailchimp-external', 'true'); // Add custom attribute for easier cleanup

      scriptExternal.onload = () => {
        // After mc-validate.js is loaded, add the inline script.
        const scriptInline = document.createElement('script');
        scriptInline.type = 'text/javascript';
        scriptInline.innerHTML = mailchimpScriptContent;
        scriptInline.setAttribute('data-mailchimp-inline', 'true'); // Add custom attribute for easier cleanup
        body.appendChild(scriptInline);
      };

      body.appendChild(scriptExternal);

      // General cleanup for when component unmounts
      return () => {
        cleanupOldMailchimpElements();
      };
    }
  }, []); // Empty dependency array means this effect runs once on mount and cleans up on unmount

  return (
    <div ref={containerRef}>
      {/* Mailchimp form will be injected here */}
    </div>
  );
};

export default MailchimpFormEmbed;